import { Component } from "react";
import { withRouter } from "../../../withRouter";
import cookie from "react-cookies";
import axios from "axios";
import $ from "jquery";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { ecommerceapiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty, isSingleSelect, isValidPrice, uploadFile, removeFile, generateId } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
import AdminCateringMenus from "./components/AdminCateringMenus";
var module = "cateringproduct";
var moduleName = "Product";
var modulePath = "/clientpanel/catering-menu";
class Form extends Component {
  constructor(props) {
    super(props);
    let allowOutlet = cookie.load("clientAllowOutlet") ?? "";
    this.state = {
      editID: this.props.params?.EditID || "",
      pageloading: false,
      clientdata: {
        productOutletID: [],
        productName: "",
        productAliasName: "",
        productSKU: "",
        productMinimumQuantity: "",
        productMaximumQuantity: "",
        productIncreaseQuantity: "",
        productSequence: "",
        productShortDescription: "",
        productLongDescription: "",
        productTag: [],
        productPrice: "",
        productCost: "",
        productEventType: "",
        productMenuType: "",
        productThumbnail: "",
        productLargeImage: "",
        productGallery: [],
        productComboSet: [],
        productUpgrades: [],
        productAddOns: [],
        productGroup:[],
        productStatus: "",
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      formpost: [],
      companyDetail: [],
      outletList: [],
      productTagList: [],
      productEventTypeList: [],
      productMenuTypeList: [],
      allowOutlet: allowOutlet,
    };
    this.handleChange = this.handleChange.bind(this);
  }
  componentDidMount() {
    this.loadOutlet();
    this.laodDropDownList();

    if (this.state.editID !== "") {
      var params = {
        params: "",
        url: `${ecommerceapiUrl}${module}/detail/${this.state.editID}`,
        type: "client",
      };
      this.setState({ pageloading: true });
      this.props.getDetailData(params);
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath, {
              state: this.props.location.state,
            });
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata && this.state.editID !== "") {
      this.setState({ companyDetail: nextProps.detaildata }, () => {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;
          var productStatus = result.productStatus === "A" ? "Active" : "Inactive";
          var status =
            result.productStatus !== "" && result.productStatus !== null
              ? {
                  label: productStatus,
                  value: result.productStatus,
                }
              : "";

          const productComboSet = result?.productComboSet || "";
          const productUpgrades = result?.productUpgrades || "";
          const productAddOns = result?.productAddOns || "";
          const productGroup = result?.productGroup || "";

          var clientupdatedata = {
            productOutletID: result?.productOutletID ?? [],
            productName: result.productName,
            productAliasName: result.productAliasName,
            productSKU: result.productSKU,
            productMinimumQuantity: result.productMinimumQuantity,
            productMaximumQuantity: result.productMaximumQuantity,
            productIncreaseQuantity: result.productIncreaseQuantity,
            productSequence: result.productSequence,
            productShortDescription: result.productShortDescription,
            productLongDescription: result.productLongDescription,
            productPrice: result.productPrice,
            productEventType: result?.productEventType || "",
            productMenuType: result?.productMenuType || "",
            productCost: result.productCost,
            productThumbnail: result.productThumbnail !== "" && result.productThumbnail !== null ? result.productThumbnail : "",
            productLargeImage: result?.productLargeImage ?? "",
            productGallery: result.productGallery !== "" && result.productGallery !== null ? result.productGallery.split(",") : [],
            productComboSet: productComboSet !== "" && productComboSet !== null ? JSON.parse(productComboSet) : [],
            productUpgrades: productUpgrades !== "" && productUpgrades !== null ? JSON.parse(productUpgrades) : [],
            productAddOns: productAddOns !== "" && productAddOns !== null ? JSON.parse(productAddOns) : [],
            productGroup:productGroup !== "" && productGroup !== null ? JSON.parse(productGroup) : [],
            productTag: result?.productTag ?? [],
            productStatus: status,
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.navigate(modulePath, {
            state: this.props.location.state,
          });
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }
  loadOutlet() {
    var urlShringTxt = ecommerceapiUrl + "outlet/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ outletList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getFlattenedOptions(data) {
    return data.map((category) => ({
      label: category.label, // Main category label
      value: category._id,
      options: category.options.map((option) => ({
        ...option,
        parentId: category._id, // Attach parent _id
      })),
    }));
  }

  laodDropDownList() {
    const urlShringTxt = ecommerceapiUrl + "cateringtag/dropDownList";
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ productTagList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });

    const urlETShringTxt = ecommerceapiUrl + "cateringeventtype/dropDownList";
    axios
      .get(urlETShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ productEventTypeList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });

    const urlMTShringTxt = ecommerceapiUrl + "cateringmenutype/dropDownList";
    axios
      .get(urlMTShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ productMenuTypeList: res.data.result });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value) => {
    this.setState(update(this.state, { clientdata: { [field]: { $set: value } } }));
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    let productOutletID = postData.productOutletID.length > 0 ? postData.productOutletID.map((item) => item.value) : [];

    let productTag = postData.productTag.length > 0 ? postData.productTag.map((item) => item.value) : [];

    const editorContent = $("#editorContent").val();
    const editorContent1 = $("#editorContent1").val();

    let postObject = {
      productOutletID: productOutletID.length > 0 ? productOutletID.join(",") : "",
      productName: postData.productName,
      productAliasName: postData.productAliasName,
      productSKU: postData.productSKU,
      productShortDescription: editorContent,
      productLongDescription: editorContent1,
      productMinimumQuantity: postData.productMinimumQuantity,
      productMaximumQuantity: postData.productMaximumQuantity,
      productIncreaseQuantity: postData.productIncreaseQuantity,
      productSequence: postData.productSequence,
      productTag: productTag.length > 0 ? productTag.join(",") : "",
      productPrice: postData.productPrice,
      productCost: postData.productCost,
      productEventType: postData.productEventType?.value || "",
      productMenuType: postData.productMenuType?.value || "",
      productThumbnail: postData.productThumbnail,
      productLargeImage: postData.productLargeImage,
      productGallery: postData.productGallery.length > 0 ? postData.productGallery.join(",") : "",
      productComboSet: postData.productComboSet.length > 0 ? JSON.stringify(postData.productComboSet) : '',
      productUpgrades: postData.productUpgrades.length > 0 ? JSON.stringify(postData.productUpgrades) : '',
      productAddOns: postData.productAddOns.length > 0 ? JSON.stringify(postData.productAddOns) : '',
      productAddOns: postData.productAddOns.length > 0 ? JSON.stringify(postData.productAddOns) : '',
      productGroup: postData.productGroup.length > 0 ? JSON.stringify(postData.productGroup) : '',
      productStatus: postData.productStatus?.value ?? "A",
    };

    var post_url = module;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${this.state.editID}`;
      method = "update";
    }
    this.props.getFormPost(postObject, post_url, "client", method, "ecom");
  };

  goBack(e) {
    e.preventDefault();
    this.props.navigate(modulePath, {
      state: this.props.location.state,
    });
  }

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"catering-menu"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">
                      {this.state.editID !== "" ? "Update" : "Add New"} {moduleName}
                    </h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end">
                    <a href="/" onClick={this.goBack.bind(this)}>
                      <button type="button" className="btn btn-outline-primary waves-effect">
                        Back
                      </button>
                    </a>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  outletList={this.state.outletList}
                  productTagList={this.state.productTagList}
                  productEventTypeList={this.state.productEventTypeList}
                  productMenuTypeList={this.state.productMenuTypeList}
                  allowOutlet={this.state.allowOutlet}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                          },
                          500,
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method, urlType) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method, urlType });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { productName, productSKU, productPrice, productCost, productStatus, productEventType, productMenuType } = props.fields;

  return {
    fields: ["productName", "productSKU", "productPrice", "productCost", "productStatus", "productEventType", "productMenuType"],

    validations: {
      productName: [[isEmpty, productName]],
      productSKU: [[isEmpty, productSKU]],
      productPrice: [
        [isEmpty, productPrice],
        [isValidPrice, productPrice],
      ],
      productCost: [[isValidPrice, productCost]],
      productStatus: [[isSingleSelect, productStatus]],
      productEventType: [[isSingleSelect, productEventType]],
      productMenuType: [[isSingleSelect, productMenuType]],
    },
  };
}

const isCheckingStock = () => {};

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
    this.setLongContent = this.setLongContent.bind(this);
  }

  goBack(e) {
    e.preventDefault();
    this.props.navigate(modulePath, {
      state: this.props.location.state,
    });
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("productShortDescription", value);
  }
  setLongContent(value) {
    this.props.onChange("productLongDescription", value);
  }

  myFilter(elm) {
    return elm != null && elm !== false && elm !== "";
  }
  async uplaodGalleryImage() {
    this.props.sateValChange("btndisabled", true);
    var imagefile = document.querySelector("#gallery_images");
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "products", "client", "ecom");
    if (fileDetail.status === "ok") {
      var productGallery = this.props.fields.productGallery;
      productGallery.push(fileDetail.url);
      this.props.onChange("productGallery", productGallery);
    }
    $("#gallery_images").val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeGalleryImage(fileNamme, removeIndex) {
    showLoader("galleryDetails_".removeIndex);
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader("galleryDetails_".removeIndex);
      var productGallery = this.props.fields.productGallery;
      productGallery.splice(removeIndex, 1);
      this.props.onChange("productGallery", productGallery);
    }
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    if (imageType === "productThumbnail") {
      showLoader("ImageDetails");
      showLoader("ImageContainer");
    } else {
      showLoader("LargeImageDetails");
      showLoader("LargeImageContainer");
    }

    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "products", "client", "ecom");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    if (imageType === "productThumbnail") {
      hideLoader("ImageContainer");
      hideLoader("ImageDetails");
    } else {
      hideLoader("LargeImageContainer");
      hideLoader("LargeImageDetails");
    }
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType) {
    if (imageType === "productThumbnail") {
      showLoader("ImageDetails", "class");
    } else {
      showLoader("LargeImageDetails", "class");
    }
    var fileDetail = await removeFile(fileNamme, "client", "ecom");
    if (fileDetail.status === "ok") {
      if (imageType === "productThumbnail") {
        hideLoader("ImageDetails", "class");
      } else {
        hideLoader("LargeImageDetails", "class");
      }
      this.props.onChange(imageType, "");
    }
  }

  saveCategory(category, type, updateIndex) {
    let productComboSet = this.props.fields.productComboSet;
    if (type === "add") {
      let updCategory = category;
      updCategory.id = generateId();
      updCategory.display_order = productComboSet.length;
      updCategory.items = [];
      productComboSet.push(updCategory);
    } else if (type === "update") {
      productComboSet = productComboSet.map((cat) => {
        if (cat.id === updateIndex) {
          return {
            ...cat,
            ...category,
            items: cat.items,
          };
        }

        return cat;
      });
    } else if (type === "sort") {
      productComboSet = category;
    }
    this.props.onChange("productComboSet", productComboSet);
  }

  saveProduct(product, type, categoryID, updateID) {
    let productComboSet = this.props.fields.productComboSet;
    if (type === "add") {
      productComboSet = productComboSet.map((cat) => {
        if (cat.id === categoryID) {
          const items = cat.items || [];
          const newItem = {
            ...product,
            id: generateId(),
            display_order: items.length === 0 ? 1 : items.length, // ✅ ADD THIS
          };
          return {
            ...cat,
            items: [...items, newItem],
          };
        }
        return cat;
      });
    } else if (type === "update") {
      productComboSet = productComboSet.map((cat) => {
        if (cat.id !== categoryID) return cat;

        return {
          ...cat,
          items: (cat.items || []).map((item) =>
            item.id === updateID
              ? {
                  ...item, // keep id & display_order
                  ...product, // overwrite editable fields
                }
              : item,
          ),
        };
      });
    } else if (type === "sort") {
      productComboSet = productComboSet.map((cat) => {
        if (cat.id !== categoryID) return cat;
        return {
          ...cat,
          items: product,
        };
      });
    }
    this.props.onChange("productComboSet", productComboSet);
  }

  saveUpgrad(upgrade, type, updateIndex) {
    let productUpgrades = this.props.fields.productUpgrades;
    if (type === "add") {
      let updupgrad = upgrade;
      updupgrad.id = generateId();
      updupgrad.display_order = productUpgrades.length;
      productUpgrades.push(updupgrad);
    } else if (type === "update") {
      productUpgrades = productUpgrades.map((cat) => {
        if (cat.id === updateIndex) {
          return {
            ...cat,
            ...upgrade,
          };
        }

        return cat;
      });
    } else if (type === "sort") {
      productUpgrades = upgrade;
    }
    this.props.onChange("productUpgrades", productUpgrades);
  }

  saveAddons(addon, type, updateIndex) {
    let productAddOns = this.props.fields.productAddOns;
    if (type === "add") {
      let updaddon = addon;
      updaddon.id = generateId();
      updaddon.display_order = productAddOns.length;
      productAddOns.push(updaddon);
    } else if (type === "update") {
      productAddOns = productAddOns.map((cat) => {
        if (cat.id === updateIndex) {
          return {
            ...cat,
            ...addon,
          };
        }

        return cat;
      });
    } else if (type === "sort") {
      productAddOns = addon;
    }
    this.props.onChange("productAddOns", productAddOns);
  }
  saveGroup(group, type, updateIndex) {
    let productGroup = this.props.fields.productGroup;
    if (type === "add") {
      let updgroup = group;
      updgroup.id = generateId();
      updgroup.display_order = productGroup.length;
      productGroup.push(updgroup);
    } else if (type === "update") {
      productGroup = productGroup.map((grp) => {
        if (grp.id === updateIndex) {
          return {
            ...grp,
            ...group,
          };
        }

        return grp;
      });
    } else if (type === "sort") {
      productGroup = group;
    }
    this.props.onChange("productGroup", productGroup);
  }

  saveGroup

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsgProName,
      errMsgsku,
      errMsgStatus,
      errMsgProPrice,
      errMsgProCost,
      errMsgproductEventType,
      errMsgproductMenuType = "";
    if ($validation.productName.error.reason !== undefined) {
      errMsgProName = $validation.productName.show && <span className="error">{$validation.productName.error.reason}</span>;
    }
    if ($validation.productSKU.error.reason !== undefined) {
      errMsgsku = $validation.productSKU.show && <span className="error">{$validation.productSKU.error.reason}</span>;
    }
    if ($validation.productPrice.error.reason !== undefined) {
      errMsgProPrice = $validation.productPrice.show && <span className="error">{$validation.productPrice.error.reason}</span>;
    }
    if ($validation.productCost.error.reason !== undefined) {
      errMsgProCost = $validation.productCost.show && <span className="error">{$validation.productCost.error.reason}</span>;
    }

    if ($validation.productStatus.error.reason !== undefined) {
      errMsgStatus = $validation.productStatus.show && <span className="error">{$validation.productStatus.error.reason}</span>;
    }
    if ($validation.productEventType.error.reason !== undefined) {
      errMsgproductEventType = $validation.productEventType.show && <span className="error">{$validation.productEventType.error.reason}</span>;
    }
    if ($validation.productMenuType.error.reason !== undefined) {
      errMsgproductMenuType = $validation.productMenuType.show && <span className="error">{$validation.productMenuType.error.reason}</span>;
    }

    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div className="accordion mt-3 accordion-header-primary" id="accordionStyle1">
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button" data-bs-toggle="collapse" data-bs-target="#accordionStyle1-3" aria-expanded="true">
                  General Info
                </button>
              </h2>
              <div id="accordionStyle1-3" className="accordion-collapse collapse show  mt-3" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    {this.props.allowOutlet === "" && (
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline custm-select-box mb-4">
                          <Select
                            value={fields.productOutletID}
                            onChange={this.handleSelectChange.bind(this, "productOutletID")}
                            placeholder={"Select Outlet"}
                            options={this.props.outletList}
                            isClearable={true}
                            isMulti
                          />
                          <label className="select-box-label">Outlet</label>
                        </div>
                      </div>
                    )}

                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProName !== "" && errMsgProName !== false && errMsgProName !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productName"
                          value={fields.productName}
                          {...$field("productName", (e) => onChange("productName", e.target.value))}
                        />
                        <label htmlFor="productName">
                          Product Name <span className="error">*</span>
                        </label>
                        {errMsgProName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productAliasName"
                          value={fields.productAliasName}
                          {...$field("productAliasName", (e) => onChange("productAliasName", e.target.value))}
                        />
                        <label htmlFor="productAliasName">Alias Name</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgsku !== "" && errMsgsku !== false && errMsgsku !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productSKU"
                          value={fields.productSKU}
                          {...$field("productSKU", (e) => onChange("productSKU", e.target.value))}
                        />
                        <label htmlFor="productSKU">
                          SKU <span className="error">*</span>
                        </label>
                        {errMsgsku}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProPrice !== "" && errMsgProPrice !== false && errMsgProPrice !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productPrice"
                          value={fields.productPrice}
                          {...$field("productPrice", (e) => onChange("productPrice", e.target.value))}
                        />
                        <label htmlFor="productPrice">
                          Product Price <span className="error">*</span>
                        </label>
                        {errMsgProPrice}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={errMsgProCost !== "" && errMsgProCost !== false && errMsgProCost !== undefined ? "form-control is-invalid" : "form-control"}
                          name="productCost"
                          value={fields.productCost}
                          {...$field("productCost", (e) => onChange("productCost", e.target.value))}
                        />
                        <label htmlFor="productCost">Product Cost</label>
                        {errMsgProCost}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productMinimumQuantity"
                          value={fields.productMinimumQuantity}
                          {...$field("productMinimumQuantity", (e) => onChange("productMinimumQuantity", e.target.value))}
                        />
                        <label htmlFor="productMinimumQuantity">Minimum Quantity</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productMaximumQuantity"
                          value={fields.productMaximumQuantity}
                          {...$field("productMaximumQuantity", (e) => onChange("productMaximumQuantity", e.target.value))}
                        />
                        <label htmlFor="productMaximumQuantity">Maximum Quantity</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productIncreaseQuantity"
                          value={fields.productIncreaseQuantity}
                          {...$field("productIncreaseQuantity", (e) => onChange("productIncreaseQuantity", e.target.value))}
                        />
                        <label htmlFor="productIncreaseQuantity">Increase Quantity</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="productSequence"
                          value={fields.productSequence}
                          {...$field("productSequence", (e) => onChange("productSequence", e.target.value))}
                        />
                        <label htmlFor="productSequence">Sequence</label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label>Short Description</label>
                      <Editor IDName={"editorContent"} data={fields.productShortDescription} />
                    </div>
                    <div className="col-md-12">
                      <label>Login Description</label>
                      <Editor IDName={"editorContent1"} data={fields.productLongDescription} />
                    </div>
                    <div className={errMsgproductEventType !== "" && errMsgproductEventType !== false && errMsgproductEventType !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productEventType}
                          onChange={this.handleSelectChange.bind(this, "productEventType")}
                          placeholder="Select Event Type"
                          options={this.props.productEventTypeList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Event Type</label>
                        {errMsgproductEventType}
                      </div>
                    </div>
                    <div className={errMsgproductMenuType !== "" && errMsgproductMenuType !== false && errMsgproductMenuType !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productMenuType}
                          onChange={this.handleSelectChange.bind(this, "productMenuType")}
                          placeholder="Select Menu Type"
                          options={this.props.productMenuTypeList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Menu Type</label>
                        {errMsgproductMenuType}
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productTag}
                          isMulti
                          onChange={this.handleSelectChange.bind(this, "productTag")}
                          placeholder="Select Tags"
                          options={this.props.productTagList}
                          isClearable={true}
                        />
                        <label className="select-box-label">Tags</label>
                      </div>
                    </div>
                    <div className={errMsgStatus !== "" && errMsgStatus !== false && errMsgStatus !== undefined ? "col-md-6 error-select error" : "col-md-6"}>
                      <div className="form-floating form-floating-outline custm-select-box mb-4">
                        <Select
                          value={fields.productStatus}
                          onChange={this.handleSelectChange.bind(this, "productStatus")}
                          placeholder="Select Status"
                          options={[
                            { value: "A", label: "Active" },
                            { value: "I", label: "Inactive" },
                          ]}
                          isClearable={true}
                        />
                        <label className="select-box-label">Status</label>
                        {errMsgStatus}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordiongallery" aria-expanded="false">
                  Gallery
                </button>
              </h2>

              <div id="accordiongallery" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Thumbnail Image
                          </label>
                          <br />
                          <span>Recommended Size 250 X 120 PX</span>
                          <input
                            className="form-control"
                            type="file"
                            id="productThumbnail"
                            onChange={(event) => {
                              this.uplaodFiles("productThumbnail", event);
                              return false;
                            }}
                          />
                        </div>
                      </div>
                      {fields.productThumbnail !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="ImageDetails">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productThumbnail} />
                            </div>
                          </div>
                          <a className="dz-remove" href={() => false} onClick={this.removeImage.bind(this, fields.productThumbnail, "productThumbnail")}>
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>
                    <div className="col-md-12">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="LargeImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Zoom Or Large Image
                          </label>
                          <br />
                          <span>Recommended Size 1000 X 1000 PX</span>
                          <input
                            className="form-control"
                            type="file"
                            id="productLargeImage"
                            onChange={(event) => {
                              this.uplaodFiles("productLargeImage", event);
                              return false;
                            }}
                          />
                        </div>
                      </div>
                      {fields.productLargeImage !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details" id="LargeImageDetails">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.productLargeImage} />
                            </div>
                          </div>
                          <a className="dz-remove" href={() => false} onClick={this.removeImage.bind(this, fields.productLargeImage, "productLargeImage")}>
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>

                    <div className="col-md-12">
                      <div className="card mb-4">
                        <h5 className="card-header">Gallery Images</h5>
                        <div className="card-body">
                          <div className="dz-message needsclick">
                            Drop files here or click to upload
                            <span className="note needsclick">
                              (This is just a demo dropzone. Selected files are <strong>not</strong> actually uploaded.)
                            </span>
                          </div>
                          <div className="fallback">
                            <input
                              name="file"
                              type="file"
                              id="gallery_images"
                              onChange={(event) => {
                                this.uplaodGalleryImage(event);
                                return false;
                              }}
                            />
                          </div>
                          {fields.productGallery.length > 0 &&
                            fields.productGallery.map((item, index) => {
                              return (
                                <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete" key={index} id={`galleryDetails_${index}`}>
                                  <div className="dz-details">
                                    <div className="dz-thumbnail">
                                      <img alt="" src={item} />
                                    </div>
                                  </div>
                                  <a className="dz-remove" href={() => false} onClick={this.removeGalleryImage.bind(this, item, index)}>
                                    Remove file
                                  </a>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button type="button" className="accordion-button collapsed" data-bs-toggle="collapse" data-bs-target="#accordioncategory" aria-expanded="false">
                  Categories, Upgrades & Add-ons
                </button>
              </h2>

              <div id="accordioncategory" className="accordion-collapse collapse" data-bs-parent="#accordionStyle1">
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-12">
                      <AdminCateringMenus
                        menuCategory={fields.productComboSet}
                        menuUpgrades={fields.productUpgrades}
                        menuAddons={fields.productAddOns}
                        productGroup={fields.productGroup}
                        saveCategory={this.saveCategory.bind(this)}
                        saveProduct={this.saveProduct.bind(this)}
                        saveUpgrad={this.saveUpgrad.bind(this)}
                        saveAddons={this.saveAddons.bind(this)}
                        saveGroup={this.saveGroup.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
            <a href="/" onClick={this.goBack.bind(this)}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </a>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
